import request from './request';

const settingService = {
  getGeneral: (params) => request.get('dashboard/admin/settings/general', { params }),
  updateGeneral: (data) => request.put('dashboard/admin/settings/general', data, {}),
  getStore: (params) => request.get('dashboard/admin/settings/store', { params }),
  updateStore: (data) => request.put('dashboard/admin/settings/store', data, {}),
  /** Enabled checkout method slugs (see docs/nextjs-admin-order-management.md). */
  getPaymentMethods: () =>
    request.get('dashboard/admin/settings/payment-methods'),
  updatePaymentMethods: (body) =>
    request.put('dashboard/admin/settings/payment-methods', body, {}),
  get: (params) => request.get('dashboard/admin/settings', { params }),
  update: (data) => request.post(`dashboard/admin/settings`, data, {}),
  /** Site-wide / homepage SEO — see SEO-ADMIN-GUIDE.md section 4. */
  getSeo: (params) => request.get('dashboard/admin/settings/seo', { params }),
  updateSeo: (data) => request.put('dashboard/admin/settings/seo', data, {}),
};

export default settingService;
